//Startup
export const STARTUP_STARTED = 'STARTUP_STARTED'
export const STARTUP_COMPLETED = 'STARTUP_COMPLETED'

//i18n
export const I18N_LOADING_STARTED = 'I18N_LOADING_STARTED'
export const I18N_LOADING_COMPLETED = 'I18N_LOADING_COMPLETED'

//Login
export const LOGIN_STARTED = 'LOGIN_STARTED'
export const LOGIN_COMPLETED = 'LOGIN_COMPLETED'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGIN_LOGOUT = 'LOGIN_LOGOUT'

//homePage
export const HOMEPAGE_SAVE = 'HOMEPAGE_SAVE' 
export const HOMEPAGE_CANCEL = 'HOMEPAGE_CANCEL'
export const ACCOUNT_CHANGE = 'ACCOUNT_CHANGE'
export const ACCOUNT_CHANGE_OLD = 'ACCOUNT_CHANGE_OLD'
export const ACCOUNT_EDIT = 'ACCOUNT_EDIT'
export const LOADED_INITIAL_DROPDOWN = 'LOADED_INITIAL_DROPDOWN'
export const LBB_SEARCH = 'LBB_SEARCH'
export const ACCOUNT_IDS='ACCOUNT_IDS'
export const ADDRESS_CHANGE='ADDRESS_CHANGE'
//contacts
export const CONTACT_CHANGE = 'CONTACT_CHANGE'
export const CONTACT_CHANGE_SELECT = 'CONTACT_CHANGE_SELECT'
export const ADD_CONTACT = 'ADD_CONTACT'
export const REMOVE_CONTACT = 'REMOVE_CONTACT'
export const CONTACT_TYPE_DELETE= 'CONTACT_TYPE_DELETE'
//po preference
export const PO_PREFERENCE_CHANGE = 'PO_PREFERENCE_CHANGE'
export const PO_PREFERENCE_CHANGE_SELECT = 'PO_PREFERENCE_CHANGE_SELECT'
export const ADD_PO_PREFERENCE = 'ADD_PO_PREFERENCE'
export const REMOVE_PO_PREFERENCE = 'REMOVE_PO_PREFERENCE'
//account numbers
export const ACCOUNT_NUMBERS_CHANGE = 'ACCOUNT_NUMBERS_CHANGE'
export const ACCOUNT_NUMBERS_CHANGE_SELECT = 'ACCOUNT_NUMBERS_CHANGE_SELECT'
export const ADD_ACCOUNT_NUMBERS = 'ADD_ACCOUNT_NUMBERS'
export const REMOVE_ACCOUNT_NUMBERS = 'REMOVE_ACCOUNT_NUMBERS'
//notifications
export const NOTIFICATION_CHANGE = 'NOTIFICATION_CHANGE'
export const NOTIFICATION_CHANGE_SELECT = 'NOTIFICATION_CHANGE_SELECT'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
//tire
export const TIRE_CHANGE = 'TIRE_CHANGE'
export const TIRE_CHANGE_SELECT = 'TIRE_CHANGE_SELECT'
export const ADD_TIRE = 'ADD_TIRE'
export const REMOVE_TIRE = 'REMOVE_TIRE'
//wheel
export const WHEEL_CHANGE = 'WHEEL_CHANGE'
export const WHEEL_CHANGE_SELECT = 'WHEEL_CHANGE_SELECT'
export const ADD_WHEEL = 'ADD_WHEEL'
export const REMOVE_WHEEL = 'REMOVE_WHEEL'
//form dialog
export const OPEN_DIALOG = 'OPEN_DIALOG'
export const CLOSE_DIALOG = 'CLOSE_DIALOG'
export const DIALOG_CHANGE = 'DIALOG_CHANGE'
export const DIALOG_CHANGE_SELECT = 'DIALOG_CHANGE_SELECT'
export const DIALOG_SEARCH = 'DIALOG_SEARCH'
export const CLOSE_NESTED_DIALOG = 'CLOSE_NESTED_DIALOG'
export const LOAD_PREF= 'LOAD_PREF'
export const CLEAR= 'CLEAR'

export const DOMAIN_CHANGE='DOMAIN_CHANGE'
export const LOAD_SHIP_TOS='LOAD_SHIP_TOS'
export const LOAD_BILL_TOS='LOAD_BILL_TOS'

export const STARTING_SAVE='STARTING_SAVE'
export const SNACK_CLOSE='SNACK_CLOSE'
export const PO_REQUIRED_CHANGE_ACTION='PO_REQUIRED_CHANGE_ACTION'
export const CC_REQUIRED_CHANGE_ACTION = 'CC_REQUIRED_CHANGE_ACTION'
export const SAVE_ERROR = 'SAVE_ERROR'

//INBOUND NUMBERS
export const FETCH_NUMBERS = 'FETCH_NUMBERS'
export const NEW_INBOUND_PROGRAM = 'NEW_INBOUND_PROGRAM'
export const NEW_SELECT_INBOUND_PROGRAM = 'NEW_SELECT_INBOUND_PROGRAM'
export const BAD_INBOUND_SAVE = 'BAD_INBOUND_SAVE'
export const ADD_INBOUND = 'ADD_INBOUND'
export const CLOSE_INBOUND = 'CLOSE_INBOUND'
export const STARTING_INBOUND = 'STARTING_INBOUND'
export const OPEN_EDIT = 'OPEN_EDIT'
export const CLOSE_EDIT = 'CLOSE_EDIT'
export const SAVE_INBOUND_EDIT = 'SAVE_INBOUND_EDIT'
export const EDIT_INBOUND_PROGRAM = 'EDIT_INBOUND_PROGRAM'
export const EDIT_SELECT_INBOUND_PROGRAM = 'EDIT_SELECT_INBOUND_PROGRAM'
export const BAD_INBOUND_EDIT_SAVE = 'BAD_INBOUND_EDIT_SAVE'
export const NEW_CHANGE_CUSTOMER_NAME = 'NEW_CHANGE_CUSTOMER_NAME'
export const LOAD_NEW_CUSTOMER = 'LOAD_NEW_CUSTOMER' 
export const START_SEARCH_SHIP_ACTION = 'START_SEARCH_SHIP_ACTION'
export const SHIP_TO_SEARCH_CHANGE_ACTION='SHIP_TO_SEARCH_CHANGE_ACTION'
export const LOAD_SHIP_TO = 'LOAD_SHIP_TO'
export const CLOSE_EDIT_INBOUND = 'CLOSE_EDIT_INBOUND'


// WEBPACK FOOTER //
// ./src/actionTypes.js